import { FFImageProps } from 'src/atoms/ff/ff-image';
import { Maybe } from 'src/types/maybe';

export enum PartnerTier {
    PresentingPartner = 5,
    FifaPartner = 10,
    TournamentSponsor = 20,
    RegionalSupporter = 30,
}

export type FMHLogo = {
    image: FFImageProps;
    link: string;
};

export enum Competition {
    FWC,
    FWWC,
    FU20WC,
    FU20WWC,
    FU17WC,
    FU17WWC,
    FCWC,
    FAC,
    FBSWC,
    FFWC,
    BSFYC,
}

export enum Tiers {
    FIFA_Partners,
    FIFA_Sponsors,
    FIFA_National_Supporters,
    FIFA_Presenting_Partner,
    FIFA_Tournament_Partner,
}

type FMHLogoStripProps = {
    images: Array<FMHLogo>;
    tier: PartnerTier;
    label: string;
    isAutomaticComponentUsed?: Maybe<boolean>;
    isGeolocationEnabled?: Maybe<boolean>;
    competition?: Maybe<Competition>;
    eventId?: Maybe<string>;
    tiers?: Maybe<Array<Tiers>>;
};

export default FMHLogoStripProps;
